import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import apiToken, {
  handleApiError,
  isSuccess,
} from '@/shared/services/axiosInstance';
import { useAuthStore } from '@/shared/stores/useAuthStore';
import Button from '@/shared/components/UI/Button';
import Input from '@/shared/components/UI/Input';

import { MyPageProps } from '../types/MyPageTypes';

const MyPage = ({ userData }: MyPageProps) => {
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const verifyUser = async () => {
    try {
      const response = await apiToken.post('/api/v1/auth/login', {
        email: userData.email,
        password,
      });
      if (isSuccess(response.data)) {
        useAuthStore.getState().setToken(response.data.data.accessToken);
        sessionStorage.setItem('log_in', 'is_logged_in');
        navigate('/mypage/account');
      }
    } catch (error) {
      const errorMessage = handleApiError(error);
      console.error('Failed to verify user:', errorMessage);
      alert(
        errorMessage || 'Authentication failed. Please check your password.',
      );
    }
  };

  return (
    <section className="mx-auto">
      <div className="w-full max-w-[48rem]">
        <h4 className="ml-8 text-[1.25rem] font-bold text-[#4b5563]">
          {userData.email}
        </h4>
        <hr className="mx-auto my-6 mb-8 border border-[#ccc]" />
        <div className="ml-8">
          <h4 className="mb-3 text-[1.125rem] font-bold text-[#4b5563]">
            My Account
          </h4>
          <p className="text-[1rem] font-normal text-[#4b5563]">
            If you want to change your account information, you need to
            authenticate yourself.
          </p>
          <form
            method="post"
            onSubmit={(e) => {
              e.preventDefault();
              verifyUser();
            }}
            className="relative mt-6 w-full max-w-[42rem]"
          >
            <Input
              type="password"
              name="password"
              label="비밀번호"
              labelClassName="sr-only"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              className="mt-0 h-10 max-w-[42rem] border-2 border-[#ececec] px-8 pr-[108px] placeholder:text-[1rem] placeholder:text-[#aaa]"
            />
            <Button
              type="submit"
              variant="secondary"
              size="sm"
              className="absolute right-1 top-1 h-8 w-[92px] bg-[#4b5563] hover:bg-[#222]"
            >
              Submit
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default MyPage;
